<template>
  <div class="container is-fluid is-no-padding">
    <div class="columns is-gapless">
      <div class="column is-hidden-mobile is-3-tablet is-2-desktop mainsidebar">
        <div class="sticky">
          <SideBar />
        </div>
      </div>
      <div class="column is-9-tablet is-10-desktop maincontent">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
  import { bodyClassMixin } from '@/mixins/bodyClass'
  import SideBar from "@/views/_globals/SideBar.vue"

  export default {
    components: {
      SideBar
    },
    mixins: [ bodyClassMixin('default') ]
  }
</script>

<style lang="scss">
  @import '@/assets/scss/global';
  @import '@/assets/scss/default';
</style>
